import { useLazyQuery } from '@apollo/client';
import { FacilityOffering } from '@pass-frontend/data-access/common/edge';
import { GET_GYMS } from '@pass-frontend/features/standalone/data-access';

export interface useGymsSearchByLocationProps {
  latitude: number;
  longitude: number;
  distance: number;
}

export function useGymsSearchByLocation(serviceSector: string) {
  const [fetchLocationbasedGyms, { loading, error, data }] = useLazyQuery<{
    locationBasedFacilityOfferings: FacilityOffering[];
  }>(GET_GYMS);
  return {
    locationBasedGyms: data,
    loading,
    error,
    fetchLocationbasedGyms: (
      location: useGymsSearchByLocationProps,
      sector?: string | undefined,
    ) => {
      fetchLocationbasedGyms({
        variables: { location, serviceSector, sector, sortBy: 'distance,name' },
      });
    },
  };
}
